import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="bg-warmGray py-24 px-6" data-id="element-157">
      <div className="max-w-4xl mx-auto text-center" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold mb-10" data-id="element-160">
            The world moved inside a piece of glass, and your parents were left
            without a translator.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-161">
          <p className="text-lg md:text-xl leading-relaxed text-charcoal/80 mb-8 max-w-3xl mx-auto" data-id="element-162">
            They want to see the grandkids' graduation, they want to laugh at
            the family group chat, but they are terrified of "clicking the wrong
            thing" or "breaking the internet."
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-163">
          <p className="text-lg md:text-xl leading-relaxed text-charcoal/80 mb-12 max-w-3xl mx-auto" data-id="element-164">
            When they call you for help, they feel guilty, and you feel
            frustrated.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-165">
          <div className="bg-white inline-block px-8 py-6 rounded-2xl shadow-warm" data-id="element-166">
            <p className="text-2xl md:text-3xl font-bold text-amber font-heading" data-id="element-167">
              It's not a tech problem—it's a connection problem.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}